'use client'

import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { useRouter } from 'next/navigation'
import { useEffect, useRef, useState } from 'react'
import { Category } from '~/__generated__/graphql'
import * as GA from '~/libs/ga'
import { Colors } from '~/libs/mui/theme'

interface GenreSelectCardProps {
  category_name: string
  sub_categories: Category[]
}

export function GenreSelectCard({
  category_name,
  sub_categories,
}: GenreSelectCardProps): JSX.Element {
  const { push } = useRouter()
  const category_name_renamed = category_name === '上映時間から選ぶ' ? '上映時間' : category_name

  const [labelWidth, setLabelWidth] = useState(0)
  const textMeasureRef = useRef<HTMLDivElement>(null)

  // ラベル文字列の幅を測定して state にセット
  useEffect(() => {
    if (textMeasureRef.current) {
      const rect = textMeasureRef.current.getBoundingClientRect()
      setLabelWidth(rect.width + 32) // 余白を加味（padding相当）
    }
  }, [category_name_renamed])

  return (
    <>
      {/* 幅計測用の非表示要素 */}
      <Box
        ref={textMeasureRef}
        sx={{
          position: 'absolute',
          visibility: 'hidden',
          whiteSpace: 'nowrap',
          fontSize: 10,
          fontFamily: 'Roboto',
          padding: '0 8px',
        }}
      >
        {category_name_renamed}
      </Box>
      <FormControl
        size='small'
        focused={false}
        sx={{
          minWidth: labelWidth,
        }}
      >
        <InputLabel
          id='select-genre-label'
          shrink={false}
          sx={{
            color: Colors.color8c8c8c,
            fontSize: 10,
          }}
        >
          {category_name === '上映時間から選ぶ' ? '上映時間' : category_name}
        </InputLabel>
        <Select
          sx={{
            borderRadius: 20,
            minHeight: 0,
            height: 30,
          }}
          key={category_name}
          displayEmpty
          autoWidth
          renderValue={() => ''}
          onChange={(event) => {
            const activeSubCategory = sub_categories.find((sub) => sub.id === event.target.value)
            GA.sendEvent({
              event: 'select',
              screen: 'stream',
              category: category_name,
              action: 'filtering_pulldown',
              value: (activeSubCategory && activeSubCategory.name) ?? '',
            })
            push(`/search/categories/${event.target.value}/videos`)
          }}
        >
          {sub_categories.map((subCategory) => (
            <MenuItem
              key={subCategory.id}
              value={subCategory.id}
              sx={{
                fontWeight: 400,
                ':hover': {
                  backgroundColor: Colors.color23221F,
                  transition: 'all 0.2s cubic-bezier(0.3, 0.3, 0.3, 1)',
                },
              }}
            >
              {subCategory.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  )
}
